var $=jQuery;
$(document).ready(function () {
    // mobie 
    $(window).on('resize', function() {
        slider_mobile();
    });
    slider_mobile();
    function slider_mobile() {
        if($(window).width() <= 949){
            $(".custom-anouncement-bar  .grid").flickity({
                pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: false,
                autoPlay: 7000,
                groupCells: false,
                cellAlign: 'left',
            });
             $(".trust__icons  .static-items.col-3").flickity({
                pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: true,
                autoPlay: 7000,
                groupCells: false,
                cellAlign: 'left',
            });
             $(".brand-logos-container .brand-custom-inner").flickity({
                pageDots: true,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: true,
                autoPlay: 7000,
                groupCells: false,
                cellAlign: 'left',
            });


        }
  }
    // mobie 
    $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').click(function (e) { 
      e.preventDefault();
      $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').removeClass('showing');
      $(this).addClass('showing');
    });
    $('#verticalTitle').click(function() {
        $(this).toggleClass('active');
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });
    $('form#FacetFiltersForm button.button.button--primary').click(function() {
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });

    $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').slideUp();
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', function() {
        setEqualHeight();
    });
    $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
    ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //Slider collection list
    $('.collection-list-wrapper .collection-list').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
    });
    //End Slider collection list
});

// $(document).ready(function () {
//   const checkboxes = $('.facets_price_custom input[type="checkbox"]'); // Select all checkboxes
//   const checkboxes_all = $('.facets__list--vertical:not(.facets_price_custom) input[type="checkbox"]'); // Select all checkboxes
//   const minInput = $('input#Filter-Preis-GTE'); // Input for minimum value
//   const maxInput = $('input#Filter-Preis-LTE'); // Input for maximum value
//   const facetsForm = $('.facets__form-vertical'); // Select the form
//   const facetsHeading = $('h2#verticalTitle'); // Select the form
//   checkboxes.on('change', function () {
//     if ($(this).is(':checked')) {
//         // Remove the show class
//         $('.facets__form-vertical').removeClass('facets__form-vertical_show');
//       // Uncheck all other checkboxes
//       checkboxes.not(this).prop('checked', false);

//       // Extract values from the selected checkbox
//       const values = $(this).val().split(' - ');
//       const minValue = values[0].trim();
//       const maxValue = values[1].trim();

//       // Assign values to the inputs
//       minInput.val(minValue).trigger('input');
//       maxInput.val(maxValue).trigger('input');

      
//     } else {
//       // Reset inputs when the checkbox is unchecked
//       minInput.val('').trigger('input');
//       maxInput.val('').trigger('input');
//     }
//   });
// });
$(document).ready(function () {
  const minInput = $('input#Filter-Preis-GTE');
  const maxInput = $('input#Filter-Preis-LTE');

  $(document).on('change', '.facets__form-vertical input[type="checkbox"]', function () {
    setTimeout(() => {
        $('h2#verticalTitle').removeClass('active');
    $('.facets__form-vertical').removeClass('facets__form-vertical_show');
      }, 300);
   

    if ($(this).closest('.facets_price_custom').length) {
      const checkboxesPrice = $('.facets_price_custom input[type="checkbox"]');
      checkboxesPrice.not(this).prop('checked', false);

      if ($(this).is(':checked')) {
        const values = $(this).val().split(' - ');
        const minValue = values[0].trim();
        const maxValue = values[1].trim();
        minInput.val(minValue).trigger('input');
        maxInput.val(maxValue).trigger('input');
      } else {
        minInput.val('').trigger('input');
        maxInput.val('').trigger('input');
      }
    }
  });
});


/**** CUSTOM  PRICE ***/

